import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import "./login.css";
import { Link, useNavigate } from "react-router-dom";
import { branchmaster, logindata } from "../../services/login";
import { getpublicprivacypolicy } from "../../services/privacypolicy";

const Login = () => {
  const navigate = useNavigate();

  const [uname, setUname] = useState("");//superadmin@amytechnologies.com
  const [pass, setPass] = useState("");//Amy2024
  const [branch, setBranch] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [blist, setBlist] = useState([]);
  const [errmsg, setErrmsg] = useState("");
  const [content, setContent] = useState("");

  useEffect(() => {
    branchmaster()
      .then((res) => {
        if (res?.status === true) {
          setBlist(res?.data || []);
        } else {
          console.log("Branch API failed:", res);
        }
      })
      .catch((err) => {
        console.log("Branch API error:", err);
      });
    getpublicprivacypolicy()
      .then((res) => {
        if (res?.status === true && res.data?.content) {
          setContent(res.data.content);
        }
      })

  }, []);

  // ✅ Login Function
  function submitlogin(e) {
    e.preventDefault();
    setErrmsg("");
    setSubmitted(true);
    localStorage.clear();

    if (uname !== "" && pass !== "" && branch !== "") {
      const temp = new FormData();
      temp.append("username", uname);
      temp.append("password", pass);
      temp.append("branch_id", branch);

      logindata(temp)
        .then((response) => {
          if (response?.status === true) {
            const user = response?.data?.user_details;

            // ✅ Safe localStorage
            localStorage.setItem("UID", user?.id || "");
            localStorage.setItem("User", user?.name || "");
            localStorage.setItem("Role", user?.role || "");
            localStorage.setItem("password", pass);
            localStorage.setItem("branch", branch);
            localStorage.setItem("token", response?.data?.token || "");
            localStorage.setItem("branches", user?.branch || "");

            // ✅ Safe role navigation
            const role = user?.role;

            // 1 Super Admin, 2 Admin, 3 Manager, 4 Employee, 5 Member
            if (role == 1 || role == 2 || role == 3) {
              navigate("/superadmin/dashboard");
            } else if (role == 4) {
              navigate("/employee/dashboard");
            } else if (role == 5) {
              navigate("/member/dashboard");
            } else {
              setErrmsg("Invalid role");
            }
          } else {
            setErrmsg(response?.message || "Login failed");
          }
        })
        .catch((err) => {
          console.log("Login API error:", err);
          setErrmsg("Server error. Please try again.");
        });
    }
  }

  return (
    <div className="full-page-container">
      <Container
        fluid
        className="login-container d-flex align-items-center justify-content-center"
      >
        <Row className="login-box shadow">
          {/* LEFT SIDE */}
          <Col md={6} className="form-section p-4">
            <img
              className="logo-img mb-2"
              src={require("../../assets/images/logo/service_amylogo.png")}
              alt="logo"
            />
            <p className="text-center text-muted">
              {/* Sign in to MSR Crest Capital */}
              Sign in to DRN Wealth Group.
               {/* Sign in to Nalan Financial Solutions  */}
              {/*Sign in to AMY Fintech Software.*/}
            </p>

            <Form onSubmit={submitlogin}>
              {/* Username */}
              <Form.Group className="mb-3">
                <Form.Label className="inputtitle">Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Username"
                  value={uname}
                  onChange={(e) => setUname(e.target.value)}
                />
                {submitted && !uname && (
                  <span className="text-danger">Username is required</span>
                )}
              </Form.Group>

              {/* Password */}
              <Form.Group className="mb-3">
                <Form.Label className="inputtitle">Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter Password"
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                />
                {submitted && !pass && (
                  <span className="text-danger">Password is required</span>
                )}
              </Form.Group>

              {/* Branch */}
              <Form.Group className="mb-3">
                <Form.Label className="inputtitle">Branch</Form.Label>
                <Form.Control
                  as="select"
                  value={branch}
                  onChange={(e) => setBranch(e.target.value)}
                >
                  <option value="">Select Branch</option>
                  {blist?.map((b) => (
                    <option key={b?.id} value={b?.id}>
                      {b?.branch_name}
                    </option>
                  ))}
                </Form.Control>
                {submitted && !branch && (
                  <span className="text-danger">Branch is required</span>
                )}
              </Form.Group>

              {/* Error */}
              {errmsg && <div className="text-danger mb-2">{errmsg}</div>}

              {/* Button */}
              <Button variant="success" type="submit" className="w-100 mb-4">
                Log In
              </Button>
            </Form>
          </Col>

          {/* RIGHT SIDE */}
          <Col
            md={6}
            className="info-section d-none d-md-flex align-items-center justify-content-center"
          >
            <div className="text-center">
              <img
                className="logo-imgg mb-2"
                src={require("../../assets/images/logo/amylogo.png")}
                alt="logo"
              />
              <h3>"Transform Your Financial Operations"</h3>
              <p className="text-white">
                Digitize your finance process and boost efficiency with AMY Fintech Software.
              </p>
              <p className="text-white">
                Support: amytechnologies2024@gmail.com
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Footer */}
      <div className="footer">
        <div className="row">
          <div className="col-md-6 text-left">
            <span>
              Copyrights © 2026{" "}
              <a className="text-danger" href="https://amyfintech.com" target="_blank" rel="noreferrer">
                AMY Fintech Software
              </a>. All Rights Reserved
            </span>
          </div>
          <div className="col-md-6 text-end">
            <span>
              Powered by{" "}
              <a
                href="https://amytechnologies.in/"
                target="_blank"
                rel="noreferrer"
                className="dark-primary font-weight-bold"
              >
                AMY Technologies
              </a>
              {content &&
                <>
                  {" | "}
                  <Link to={"/privacypolicy"}
                    target="_blank"
                    rel="noreferrer">
                    Privacy Policy
                  </Link>
                </>
              }

            </span>
          </div>
        </div>
      </div>


    </div>
  );
};

export default Login;